// PDP only
export default function updateUserSpecificSections () {
  updateAddToCartButton()
  showRequestTradePriceButton()
  showPrivateOfferAvailable()
  showListingReservedBanner()
  updateWishlistButton()
  updateEnquiryButtons()
  updateMakeAnOfferButton()
  linkEnquiryButtonToExistingEnquiry()
}

function updateAddToCartButton () {
  const disabledAtc = document.querySelector('#vjs-listing__disabled-add-to-cart')
  if (!disabledAtc) return
  const atcForm = document.querySelector('#vjs-listing__atc-form')
  if (atcForm) atcForm.outerHTML = disabledAtc.outerHTML
}

function showRequestTradePriceButton () {
  const showTradePrice = document.querySelector('[data-id="show-request-trade-price"]')
  if (!showTradePrice) return
  const newEnquiryPlaceholder = document.querySelector('#vjs-new-enquiry-button-placeholder')
  if (newEnquiryPlaceholder) newEnquiryPlaceholder.classList.remove('hidden')
}

function linkEnquiryButtonToExistingEnquiry () {
  const enquiryHref = document.querySelector('input[data-id="enquiry-href"]')
  if (!enquiryHref) return
  const newEnquiryButtons = document.querySelectorAll('.vjs-new-enquiry-button')
  if (!newEnquiryButtons) return
  newEnquiryButtons.forEach(enquiryButton => {
    enquiryButton.removeAttribute('data-modal')
    enquiryButton.addEventListener('click', function () {
      document.location.href = enquiryHref.value
    })
  })
}

function showPrivateOfferAvailable () {
  const showPrivateOffer = document.querySelector('[data-id="show-private-offer-price"]')
  if (!showPrivateOffer) return

  const existingBadges = Array.from(document.getElementsByClassName('vsd-listing__images-carousel-badge'))
  existingBadges.forEach(badge => badge.classList.add('hidden'))

  const privateOfferBadge = document.querySelector('#vjs-listing__private-offer-badge')
  privateOfferBadge.classList.remove('hidden')

  const priceTagHolder = document.querySelector('#vjs-listing_big-price-tag-holder')
  const priceValueHolder = document.querySelector('#vjs-listing_big-price-value-holder')
  const basePrice = document.querySelector('.vsd-listing__big-price--strikethrough')

  if (priceTagHolder) {
    priceTagHolder.classList.remove('vsd-listing__big-trade-price')
    priceTagHolder.classList.remove('vsd-listing__big-sale-price')
    priceTagHolder.classList.add('vsd-listing__big-private-price')
  }
  if (priceValueHolder) priceValueHolder.innerHTML = showPrivateOffer.innerHTML
  if (basePrice) basePrice.classList.remove('hidden')
}

function showListingReservedBanner () {
  const holidayBanner = document.querySelector('#vjs-seller-holiday-banner')
  if (holidayBanner) return

  // these two states are not necessarily universally applicable so should not refresh the cache
  // and therefore are better handled on an individual view basis with JS
  const reservedCurrent = document.querySelector('[data-id="show-reserved-listing-current"]')
  if (reservedCurrent) document.querySelector('#vjs-reserved-listing-current-banner').classList.remove('hidden')

  const reservedOther = document.querySelector('[data-id="show-reserved-listing-other"]')
  if (reservedOther) document.querySelector('#vjs-reserved-listing-other-banner').classList.remove('hidden')
  // if (true) document.querySelector('#vjs-reserved-listing-other-banner').classList.remove('hidden')
}

function updateWishlistButton () {
  const wishlistButton = document.querySelector('[data-id="wishlist-button"]')
  if (!wishlistButton) return
  const wishlistButtonContainer = document.querySelector('#vjs-wishlist-button-container')
  if (wishlistButtonContainer) wishlistButtonContainer.innerHTML = wishlistButton.outerHTML
}

function updateEnquiryButtons () {
  const loginOrEnquiryModalId = document.querySelector('[data-id="enquiry-button"]')
  if (!loginOrEnquiryModalId) return
  const enquiryButtons = document.querySelectorAll('.vjs-new-enquiry-button')
  if (!enquiryButtons) return

  enquiryButtons.forEach(btn => {
    btn.setAttribute('data-modal', loginOrEnquiryModalId.value)
  })
}

function updateMakeAnOfferButton () {
  const loginOrMakeAnOfferModalId = document.querySelector('[data-id="make-an-offer-button"]')
  if (!loginOrMakeAnOfferModalId) return
  const makeAnOfferBtn = document.getElementById('vjs-make-an-offer-button')
  if (!makeAnOfferBtn) return

  makeAnOfferBtn.setAttribute('data-modal', loginOrMakeAnOfferModalId.value)

  makeAnOfferBtn.addEventListener('click', function () {
    const oauthAndRegisterButtons = document.querySelectorAll('.vjs-oauth-button, .vjs-register-here-link')
    oauthAndRegisterButtons.forEach(button => {
      const baseUrl = button.href.split('?')[0]

      button.href = baseUrl + '?login_purpose=make-an-offer'
    })
  })
}
